<template>
    <div>
        <div v-if="!isNaN(getTotalOfSlots())" v-show="showSlotsCounters" class="form-group">
            <label>Total</label>
            <span data-role="slot-total" :data-slot-total="getTotalOfSlots()">{{ getTotalOfSlots() }} slot(s)</span>
        </div>

        <div class="form-group">
            <label for="slot-duration">{{ durationLabel }}</label>
            <input required :disabled="!canEditDuration" id="slot-duration" min="5" step="1" type="number" name="duration" v-model="slotDuration">
        </div>

        <div v-for="(dayTimeRange, key) in dayTimeRanges">
            <div class="row align-items-end">
                <div class="form-group col-12 col-md-3" data-validation="required">
                    <label :for="`date-${key}`">{{ dateLabel }}</label>
                    <input :id="`date-${key}`" required type="date" :name="'day_time_ranges['+key+'][day]'" v-model="dayTimeRange.day">
                </div>

                <div class="form-group col-12 col-md-2" data-validation="required">
                    <label :for="`start-${key}`">{{ startLabel }}</label>
                    <input :id="`start-${key}`" required type="time" :name="'day_time_ranges['+key+'][start]'" v-model="dayTimeRange.start">
                </div>

                <div class="form-group col-12 col-md-2" data-validation="required">
                    <label :for="`end-${key}`">{{ endLabel }}</label>
                    <input :id="`end-${key}`" required type="time" :name="'day_time_ranges['+key+'][end]'" v-model="dayTimeRange.end">
                </div>

                <div class="form-group col-12 col-md-2" data-validation="required">
                    <label :for="`capacity-${key}`">{{ capacityLabel }}</label>
                    <input :id="`capacity-${key}`" required type="number" min="1" :name="'day_time_ranges['+key+'][capacity]'" v-model="dayTimeRange.capacity">
                </div>

                <div v-if="showSlotsCounters" class="form-group col-12 col-md-1">
                    <span v-if="dayTimeRange.start && dayTimeRange.end && slotDuration" class="font-weight-bold">
                        {{ getNumberOfSlots(dayTimeRange, slotDuration) }} slot(s)
                    </span>
                </div>
                <div v-else class="form-group col-12 col-md-1"></div>

                <div class="form-group col-12 col-md-2 d-flex justify-content-end">
                    <button v-if="dayTimeRanges.length > 1" type="button" class="btn-medium-grey" @click="deleteDayTimeRange(key)">{{ deleteLabel }}</button>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn-blue" @click="addDayTimeRange">{{ addLabel }}</button>
        </div>
    </div>
</template>

<script>
import moment from "moment"

export default {
    name: "DayTimeRangeForm",

    data: () => ({
        dayTimeRanges: [
           { date: null, start: null, end: null, capacity: 1 }
        ],
        slotDuration: 60,
    }),

    props: {
        showSlotsCounters: {
            default: false
        },
        oldDayTimeRanges: {
            default: null
        },
        oldDuration: {
            default: null,
        },
        canEditDuration: {
            default: true,
        },
        durationLabel: {
            default: 'Default duration'
        },
        startLabel: {
            default: 'Start'
        },
        endLabel: {
            default: 'End'
        },
        capacityLabel: {
            default: 'Capacity'
        },
        dateLabel: {
            default: 'Date'
        },
        addLabel: {
            default: 'Add'
        },
        deleteLabel: {
            default: 'Delete'
        }
    },

    created() {
        if (this.oldDayTimeRanges) {
            this.dayTimeRanges = this.oldDayTimeRanges
            if (!this.oldDuration) {
                this.slotDuration = this.findDefaultDuration()
            }
        }
        if (this.oldDuration) {
            this.slotDuration = this.oldDuration
        }
    },

    methods: {
        findDefaultDuration() {
            const previousTimeRange = this.dayTimeRanges.length > 0 ? this.dayTimeRanges[this.dayTimeRanges.length - 1] : null

            if (previousTimeRange) {
                const date = moment(previousTimeRange.day)
                const start = previousTimeRange.start
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.start)
                    : null
                const end = previousTimeRange.end
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.end)
                    : null
                return end.diff(start, 'minute')
            }

            return null
        },

        addDayTimeRange() {
            const previousTimeRange = this.dayTimeRanges.length > 0 ? this.dayTimeRanges[this.dayTimeRanges.length - 1] : null

            let nextEnd = null
            if (previousTimeRange) {
                const date = moment(previousTimeRange.day)
                nextEnd = this.slotDuration && previousTimeRange.end
                    ? moment(date.format('YYYY-MM-DD') + ' ' + previousTimeRange.end)
                        .add(this.slotDuration, 'minute')
                        .format('HH:mm')
                    : null
            }

            this.dayTimeRanges.push({
                day: previousTimeRange ? previousTimeRange.day : null,
                start: previousTimeRange ? previousTimeRange.end : null,
                end: nextEnd,
                capacity: 1,
            })
        },

        deleteDayTimeRange(index) {
            if (this.dayTimeRanges.length > 1) {
                this.dayTimeRanges.splice(index, 1)
            }
        },

        getNumberOfSlots(timeRange, slotDuration) {
            const todayMidnight = moment().startOf('day')
            const start = moment(todayMidnight.toDate().toDateString() + ' ' + timeRange.start).diff(todayMidnight, 'minutes')
            const end = moment(todayMidnight.toDate().toDateString() + ' ' + timeRange.end).diff(todayMidnight, 'minutes')
            return Math.max(Math.floor((end - start) / slotDuration), 0)
        },

        getTotalOfSlots() {
            let total = 0
            for (const dayTimeRange of this.dayTimeRanges) {
                const value = this.getNumberOfSlots(dayTimeRange, this.slotDuration)
                total += !isNaN(value) ? value : 0
            }
            return total
        }
    }
}
</script>

<style scoped>

</style>
